import { useAuthStore } from '@core/stores/auth-store'

export const AUTH_FRAGMENT_KEY = 'auth'

/**
 * Reads an auth token from the URL hash fragment (`#auth=<token>`),
 * writes it as a cookie, and cleans the hash from the URL.
 *
 * Must be called synchronously before the app renders so the
 * authentication guard sees the cookie on first evaluation.
 */
export function consumeAuthFromHash(): void {
  const { hash, pathname, search } = window.location
  if (!hash) return

  const params = new URLSearchParams(hash.slice(1))
  const token = params.get(AUTH_FRAGMENT_KEY)
  if (!token) return

  useAuthStore.getState().setAccessToken(token)
  history.replaceState(null, '', pathname + search)
}
